<div class="custom-tooltip" [class.visible]="isVisible">
  <div class="tooltip-arrow"></div>
  <div class="tooltip-content">
    <ng-container *ngTemplateOutlet="tooltipTemplate; context: { $implicit: tooltipData }"></ng-container>
  </div>
</div>
